import MuiSkeleton, { SkeletonProps } from '@mui/material/Skeleton';

export function Skeleton(props: SkeletonProps) {
  return (
   <MuiSkeleton {...props} />
  );
}
